export default ['Days', 'Weeks', 'Months']
